<template>
  <div
      class="navbar"
      :class="{'navbar_collapsed': isMenuCollapsed}"
      v-if="isEditMode"
  >
    <div
        class="navbar-collapse-icon"
        @click="changeMenuVisibility"
    >
      <span class="icon"></span>
    </div>
    <div
        class="navbar-category"
    >
      <template
          v-for="(categoryBlock) in menuLocal"
      >
        <div
            v-for="(item,itemIndex) in categoryBlock.items"
            :key="itemIndex"
            class="navbar-category__item-wrapper"
        >
          <div
              class="navbar-category__item"
              :class="{'navbar-category__item_active':routePath ===item.router}"
              @click="changePage(item.router)"

          >
            <template v-if="item.icon">
              <div
                  class="navbar-category__item-icon"
                  :style="{backgroundImage: `url(${item.icon})`,'font-size':item.fz,'font-weight':item.fw,'margin-left':item.ml}"
              ></div>
            </template>
            <template v-else-if="item.text">
              {{ item.text }}
            </template>
            <span
                class="navbar-category__item-title"
            >{{ item.title }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NavBar',
  props: {
    menu: {
      type: Array,
      required: true,
    },
    isMenuCollapsed: {
      type: Boolean,
      required: true,
    },
    menuPermissions: {
      type: Object,
      default: () => {
      },
    },
    routePath: {
      type: String,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      menuLocal: [],
    };
  },
  watch: {
    menuPermissions: {
      deep: true,
      immediate: false,
      handler() {
        this.filterMenuWithPermissions();
      },
    },
    menu: {
      deep: true,
      immediate: false,
      handler() {
        this.filterMenuWithPermissions();
      },
    },
  },
  methods: {
    changePage(router) {
      this.$emit('changePage', router);
    },
    changeMenuVisibility() {
      this.$emit('changeMenuVisibility');
    },
    filterMenuWithPermissions() {
      const menu = _.cloneDeep(this.menu);
      if (!this.menuPermissions.isEditMode) {
        const mainCategory = menu.find((m) => m.category.name === 'main');
        mainCategory.items = mainCategory.items.filter((item) => item.name === 'dashboard');
      }
      this.menuLocal = _.cloneDeep(menu);
    },
  },
};
</script>

<style
    scoped
    lang="scss"
>
.navbar {
  cursor: pointer;
  width: 200px;
  pointer-events: all;
  padding-top: 40px;
  background: #f3f6ff;
  position: sticky;
  left: 0;
  z-index: 999;


  &_collapsed {
    width: 50px;


    .navbar-category__item-title {
      display: none;
    }


  }

  &-collapse-icon {
    height: 40px;
    display: flex;
    justify-content: center;
    width: 50px;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;

    .icon {
      width: 22px;
      height: 22px;
      position: fixed;
      background-position: 0 0;
      background-repeat: no-repeat;
      background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjIycHgiIGhlaWdodD0iMTlweCIgdmlld0JveD0iMCAwIDIyIDE5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBza2V0Y2h0b29sIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4NCiAgICA8dGl0bGU+NEVCQUZBRTctNjM0Qi00RTU1LTk1M0YtMEE3OUVDQzc5NEE5QDEsNXg8L3RpdGxlPg0KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4NCiAgICA8ZyBpZD0iUGFnZS00IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9Ik1haW5fc2hvcnRfc2Nyb2xsIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQuMDAwMDAwLCAtMTEuMDAwMDAwKSIgZmlsbD0iIzAyREZCMCIgc3Ryb2tlPSIjNjA4OUU3Ij4NCiAgICAgICAgICAgIDxnIGlkPSJtZW51X3RvcCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUuMDAwMDAwLCA5LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxnIGlkPSJpY29uL2J1cmdlciIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDMuMDAwMDAwKSI+DQogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMS41LC0wLjUgTDE4LjUsLTAuNSBDMTkuNjA0NTY5NSwtMC41IDIwLjUsMC4zOTU0MzA1IDIwLjUsMS41IEMyMC41LDIuNjA0NTY5NSAxOS42MDQ1Njk1LDMuNSAxOC41LDMuNSBMMTEuNSwzLjUgQzEwLjM5NTQzMDUsMy41IDkuNSwyLjYwNDU2OTUgOS41LDEuNSBDOS41LDAuMzk1NDMwNSAxMC4zOTU0MzA1LC0wLjUgMTEuNSwtMC41IFogTTEuNSw2LjUgTDE4LjUsNi41IEMxOS42MDQ1Njk1LDYuNSAyMC41LDcuMzk1NDMwNSAyMC41LDguNSBDMjAuNSw5LjYwNDU2OTUgMTkuNjA0NTY5NSwxMC41IDE4LjUsMTAuNSBMMS41LDEwLjUgQzAuMzk1NDMwNSwxMC41IC0wLjUsOS42MDQ1Njk1IC0wLjUsOC41IEMtMC41LDcuMzk1NDMwNSAwLjM5NTQzMDUsNi41IDEuNSw2LjUgWiBNMS41LDEzLjUgTDguNSwxMy41IEM5LjYwNDU2OTUsMTMuNSAxMC41LDE0LjM5NTQzMDUgMTAuNSwxNS41IEMxMC41LDE2LjYwNDU2OTUgOS42MDQ1Njk1LDE3LjUgOC41LDE3LjUgTDEuNSwxNy41IEMwLjM5NTQzMDUsMTcuNSAtMC41LDE2LjYwNDU2OTUgLTAuNSwxNS41IEMtMC41LDE0LjM5NTQzMDUgMC4zOTU0MzA1LDEzLjUgMS41LDEzLjUgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIj48L3BhdGg+DQogICAgICAgICAgICAgICAgPC9nPg0KICAgICAgICAgICAgPC9nPg0KICAgICAgICA8L2c+DQogICAgPC9nPg0KPC9zdmc+');
    }

    img {
      position: fixed;
      padding: 11px 14px;
      background-color: $light-blue-color;
      background-position: 0 0;
      background-repeat: no-repeat;
      background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjIycHgiIGhlaWdodD0iMTlweCIgdmlld0JveD0iMCAwIDIyIDE5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBza2V0Y2h0b29sIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4NCiAgICA8dGl0bGU+NEVCQUZBRTctNjM0Qi00RTU1LTk1M0YtMEE3OUVDQzc5NEE5QDEsNXg8L3RpdGxlPg0KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4NCiAgICA8ZyBpZD0iUGFnZS00IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9Ik1haW5fc2hvcnRfc2Nyb2xsIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQuMDAwMDAwLCAtMTEuMDAwMDAwKSIgZmlsbD0iIzAyREZCMCIgc3Ryb2tlPSIjNjA4OUU3Ij4NCiAgICAgICAgICAgIDxnIGlkPSJtZW51X3RvcCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUuMDAwMDAwLCA5LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxnIGlkPSJpY29uL2J1cmdlciIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDMuMDAwMDAwKSI+DQogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMS41LC0wLjUgTDE4LjUsLTAuNSBDMTkuNjA0NTY5NSwtMC41IDIwLjUsMC4zOTU0MzA1IDIwLjUsMS41IEMyMC41LDIuNjA0NTY5NSAxOS42MDQ1Njk1LDMuNSAxOC41LDMuNSBMMTEuNSwzLjUgQzEwLjM5NTQzMDUsMy41IDkuNSwyLjYwNDU2OTUgOS41LDEuNSBDOS41LDAuMzk1NDMwNSAxMC4zOTU0MzA1LC0wLjUgMTEuNSwtMC41IFogTTEuNSw2LjUgTDE4LjUsNi41IEMxOS42MDQ1Njk1LDYuNSAyMC41LDcuMzk1NDMwNSAyMC41LDguNSBDMjAuNSw5LjYwNDU2OTUgMTkuNjA0NTY5NSwxMC41IDE4LjUsMTAuNSBMMS41LDEwLjUgQzAuMzk1NDMwNSwxMC41IC0wLjUsOS42MDQ1Njk1IC0wLjUsOC41IEMtMC41LDcuMzk1NDMwNSAwLjM5NTQzMDUsNi41IDEuNSw2LjUgWiBNMS41LDEzLjUgTDguNSwxMy41IEM5LjYwNDU2OTUsMTMuNSAxMC41LDE0LjM5NTQzMDUgMTAuNSwxNS41IEMxMC41LDE2LjYwNDU2OTUgOS42MDQ1Njk1LDE3LjUgOC41LDE3LjUgTDEuNSwxNy41IEMwLjM5NTQzMDUsMTcuNSAtMC41LDE2LjYwNDU2OTUgLTAuNSwxNS41IEMtMC41LDE0LjM5NTQzMDUgMC4zOTU0MzA1LDEzLjUgMS41LDEzLjUgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIj48L3BhdGg+DQogICAgICAgICAgICAgICAgPC9nPg0KICAgICAgICAgICAgPC9nPg0KICAgICAgICA8L2c+DQogICAgPC9nPg0KPC9zdmc+');
    }
  }

  &-category {
    position: fixed;
    left: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &__item {
      justify-content: left;
      height: 35px;
      color: $primary-color;
      font-size: 18px;
      font-weight: 500;
      align-items: center;
      padding: 10px;
      border-radius: 10px;
      display: flex;

      &-wrapper {
        margin-left: 5px;
      }

      &:hover {
        opacity: .5;
      }


      &_active {
        background: #FFFFFF;
      }

      &-title {
        padding-left: 10px;
        font-size: 16px;
      }

      &-icon {
        height: 21px;
        width: 20px;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
  }
}
</style>